import { useQuery } from '@tanstack/react-query';

import { BaseError } from '../../helpers/BaseError';

import { LanguageModel } from '../../models/languages.model';

import API from '../../services/api';

import { languagesQueryKeys } from './__queryKeys';

const getLanguagesQuery = async (): Promise<LanguageModel[]> => {
    const { data } = await API.getLanguages();
    return data;
};

export default function useLanguagesQuery() {
    return useQuery<LanguageModel[], BaseError>({
        queryKey: languagesQueryKeys.languages(),
        queryFn: () => getLanguagesQuery(),
        staleTime: 2 * 60 * 60 * 1000, // 2 hours
    });
}
